export const NODE_TYPE_PAGE = 'NODE_TYPE_PAGE';
export const NODE_TYPE_ROW = 'NODE_TYPE_ROW';
export const NODE_TYPE_FIELD = 'NODE_TYPE_FIELD';
export const NODE_TYPE_SECTION = 'NODE_TYPE_SUBSECTION';
export const NODE_TYPE_ABSTRACT = 'NODE_TYPE_ABSTRACT';
export const NODE_TYPE_CONFIGURATION = 'NODE_TYPE_CONFIGURATION';
export const NODE_TYPE_GROUP = 'NODE_TYPE_GROUP';
export const NODE_TYPE_FINISH_PAGE = 'NODE_TYPE_FINISH_PAGE';

